<template>
  <ul class="flex gap-[10px] bg-slate-100 rounded-[10px] p-4 items-center flex-wrap !m-0 !visible">
    <li v-for="(step, index) in mainSteps" :key="step">
      <div :class="['default', step == currentMainStep ? 'active' : 'inactive']">
        <span class="number">{{ index + 1 }}</span>
        <div class="hidden !visible md:!flex" v-if="interest != null">
          <span v-if="!isFührerschein && step == MainStep.FÜHRERSCHEINKLASSEN">Fahrzeugtyp</span>
          <span v-else>{{ step }}</span>
        </div>
      </div>
    </li>
  </ul>
</template>

<script setup>
import { computed } from 'vue';
import { MainStep } from '../models/enums';
import { useStore } from 'vuex';

const store = useStore();
const interest = computed(() => store.state.preInterest);
const isFührerschein = computed(() => store.getters.IS_FÜHRERSCHEIN);
const currentMainStep = computed(() => store.getters.MAINSTEP);
const mainSteps = Object.values(MainStep);

</script>

<style scoped lang="scss">
.default {
  @apply bg-white text-slate-500;
  @apply rounded-md px-3.5 py-2.5 text-sm font-normal shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2;
  @apply flex gap-[10px] items-center;

  .number {
    @apply bg-slate-100 text-slate-300;
    @apply rounded-full h-6 w-6 flex justify-center items-center;
  }

  &.active {
    @apply bg-blue-600 text-white;
    .number {
      @apply bg-blue-500 text-blue-300;
    }
  }
}
</style>